// src/components/quizzes/BonusDollarsCents.js
//
// Dollars & cents bonus round: catch coins that add up to the amount.
// Runs on the shared bonus-round engine (kit/BonusShell.js) — the
// BonusDiamonds look, bombs, bonus stars, clocks, combos, a new question
// every few right answers, and 🏁 End game. Same contract as before:
// BonusRouter renders <ThisGame onBonusComplete questions placeholderImage />.

import React from "react";
import BonusShell from "./kit/BonusShell";

/** ======= COINS ======= */
const COINS = [
  { name: "Quarter", value: 25, img: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/gameimages%2Fquarter.png?alt=media&token=e9a42495-3056-49a0-b043-c3292d40b88e" },
  { name: "Dime",    value: 10, img: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/gameimages%2Fdime.png?alt=media&token=41fd5b7a-a794-416b-a328-74e6df5a4aaf" },
  { name: "Nickel",  value: 5,  img: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/gameimages%2Fnickel.png?alt=media&token=18e9c158-5a35-4cfe-bd94-868beb12506d" },
  { name: "Penny",   value: 1,  img: "https://firebasestorage.googleapis.com/v0/b/sbleducationalportal.firebasestorage.app/o/gameimages%2Fpenny.png?alt=media&token=c2f2aa31-9717-434c-a598-18b71a555743" },
];

/** ======= GAME KNOBS ======= */
const TIMER_SECONDS = 40;    // round duration
const SPAWN_MS = 500;        // coin spawn rate
    // seconds
    // seconds

// target amounts in cents (mix of easy & medium; adjust as you like)
const TARGET_POOL = [15, 18, 20, 25, 27, 30, 31, 34, 35, 36, 40, 41, 43, 45, 47, 50, 52, 55, 57, 60];

/** ======= HELPERS ======= */
const formatCents = (c) => `$${(c/100).toFixed(2)}`;
const randomFrom = (arr) => arr[Math.floor(Math.random() * arr.length)];

const sumOf = (bank) => bank.reduce((s, c) => s + c.value, 0);

const DollarsCentsBonus = (props) => (
  <BonusShell
    {...props}
    title="Make the Amount!"
    emoji="💰"
    sub="Catch coins that add up to the amount — don't go over!"
    intro="Make the amount with coins. Catch quarters, dimes, nickels and pennies that add up to the amount at the top. Each coin that helps is worth five points. Going over takes away ten points. Watch out for bombs! Press Start when you are ready."
    rules={[
      { icon: "🪙", text: "A coin that still fits", pts: "+5" },
      { icon: "❌", text: "A coin that goes over", pts: "-10" },
      { icon: "🎯", text: "Make it exactly — then a new amount!" },
    ]}
    init={(prev) => ({ target: randomFrom(TARGET_POOL.filter((t) => !prev || t !== prev.target)), bank: [] })}
    prompt={(s) => {
      const have = sumOf(s.bank);
      return {
        big: `Make ${formatCents(s.target)}`,
        small: have ? `You have ${formatCents(have)} — ${formatCents(s.target - have)} to go` : "Catch coins to add up to it!",
        say: `Make ${formatCents(s.target)}. Don't go over!`,
        extra: s.bank.length
          ? s.bank.map((c, i) => (
              <span className="bs-chip" key={`${c.name}-${i}`}>
                <img src={c.img} alt="" /> {c.value}¢
              </span>
            ))
          : null,
      };
    }}
    spawn={(s) => {
      const left = s.target - sumOf(s.bank);
      const fits = COINS.filter((c) => c.value <= left);
      return Math.random() < 0.6 && fits.length ? randomFrom(fits) : randomFrom(COINS);
    }}
    check={(s, coin) => sumOf(s.bank) + coin.value <= s.target}
    onRight={(s, coin) => {
      const bank = [...s.bank, coin];
      if (sumOf(bank) === s.target) {
        const next = randomFrom(TARGET_POOL.filter((t) => t !== s.target));
        return { state: { target: next, bank: [] }, clear: false, flash: "🎯 You made it!", say: `Great! Now make ${formatCents(next)}.` };
      }
      return { state: { ...s, bank } };
    }}
    label={(c) => (
      <span style={{ display: "grid", placeItems: "center", gap: 2 }}>
        <img src={c.img} alt={c.name} style={{ width: 62, height: 62 }} />
        <span style={{ fontSize: 15 }}>{formatCents(c.value)}</span>
      </span>
    )}
    badPoints={10}
    itemSize={104}
    seconds={Math.max(30, TIMER_SECONDS)}
    spawnMs={SPAWN_MS}
    slowGood={1}
    caughtLabel="Coins"
  />
);

export default DollarsCentsBonus;
